import MUIMenuItem from "@material-ui/core/MenuItem";

const MenuItem = ({ children, ...otherProps }) => {
  return <MUIMenuItem {...otherProps}>{children}</MUIMenuItem>;
};

export default MenuItem;
